import React, {useEffect, useState} from 'react';
import * as yup from 'yup';
import {Controller, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import InputMUI from '../../../../shared/InputMUI';
import ButtonMUI from '../../../../shared/ButtonMUI';
import SelectComponent from '../../../../shared/SelectComponent';
import {getCompanyEmployeeList, postCompanyEmployeeCreate} from '../../../../redux/actions/employee/employeeActions';
import {getUserRoles} from '../../../../redux/actions/profile/profileActions';
import {getCompanyEmployeeAdding} from '../../../../redux/actions/employee/employeeActions';
import {useDispatch, useSelector} from 'react-redux';
import {AutocompleteMUI} from '../../../../shared';
import {notifySuccess} from '../../../../helpers/notifySnack';
import {useTranslation} from 'react-i18next';
import './EmployeesAdd.scss';
import {getCompany} from '../../../../redux/actions/company/companyActions';
import {mainPath} from '../../../../routes/paths';
import CompaniesHero from '../CompaniesHero';
import {useHistory} from 'react-router-dom';
import {passwordRegex} from "../../../../helpers/constants";
import {formatRolesByIerarchion} from "../../../../helpers/functions";

const EmployeesAdd = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [buttonLoad, setButtonLoad] = useState(false);

    const {userRoles, profileMe} = useSelector((state) => state.profile);
    const {companyEmployeesAdding} = useSelector((state) => state.employee);
    const {singleCompany} = useSelector((state) => state.company);
    const {companyEmployeesList, companyEmployeesListLoading} = useSelector((state) => state.employee);

    useEffect(() => {
        if (companyEmployeesListLoading && !companyEmployeesList.length && singleCompany.id) {
            dispatch(getCompanyEmployeeList(singleCompany.id));
        }
    }, [dispatch, singleCompany?.id, companyEmployeesListLoading]);

    useEffect(() => {
        if (singleCompany?.id) {
            dispatch(getUserRoles('employee'));
            dispatch(getCompanyEmployeeAdding(singleCompany?.id));
        }
    }, [dispatch, singleCompany?.id]);

    const formattedRoles = formatRolesByIerarchion(profileMe?.role, userRoles);

    const position = formattedRoles?.map((role) => ({
        id: role.id,
        role: role.role,
        name: role.name
    }));

    const schema = yup.object({
        position: yup.string().when('employee', {
            is: (employee) => employee.length === 0,
            then: yup.string().required(t('validations.required')),
            otherwise: yup.string().notRequired(),
        }),
        firstName: yup.string().when('employee', {
            is: (employee) => !employee || employee.length === 0,
            then: yup.string().required(t('validations.required')),
            otherwise: yup.string().notRequired(),
        }),
        phone: yup.string().when('employee', {
            is: (employee) => !employee || employee.length === 0,
            then: yup.string().required(t('validations.required')),
            otherwise: yup.string().notRequired(),
        }),
        email: yup.string().email(t('validations.email')).when('employee', {
            is: (employee) => !employee || employee.length === 0,
            then: yup.string().required(t('validations.required')),
            otherwise: yup.string().notRequired(),
        }),
        password: yup.string().when('employee', {
            is: (employee) => !employee || employee.length === 0,
            then: yup.string().matches(passwordRegex, t('validations.password')).required(t('validations.required')),
            otherwise: yup.string().notRequired(),
        }),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: {errors, isValid},
        watch,
        clearErrors
    } = useForm({
        mode: 'all',
        reValidateMode: 'onChange',
        shouldFocusError: true,
        resolver: yupResolver(schema),
        defaultValues: {
            employee: [],
            position: '',
            firstName: '',
            phone: '',
            email: '',
            password: ''
        }
    });


    const formValues = watch();
    const isEmployeeFilled = formValues?.employee?.length > 0
    const isAnyFieldFilled = Object.keys(formValues)
        .filter((key) => key !== 'employee')
        .some((key) => formValues[key] !== '' && formValues[key] !== null);

    const employeeArr = formValues?.employee?.length > 0 ? [] : companyEmployeesAdding.map((item) => {
        return {
            label: item.firstName ?? '',
            id: item.id,
            avatar: item.avatar.thumbnail ?? '',
            text: item.positionName ?? ''
        };
    });


    const onSubmit = async (data) => {
        const formData = new FormData();
        setButtonLoad(true);
        try {
            if (data.employee?.length) {
                formData.append('id', data.employee[0].id);
            } else {
                const selectedRole = position.find((role) => role.id === data.position);
                formData.append('position', selectedRole.role);
                formData.append('firstName', data.firstName);
                formData.append('phone', data.phone);
                formData.append('email', data.email);
                formData.append('password', data.password);
            }

            const res = await dispatch(postCompanyEmployeeCreate(formData, singleCompany?.id));
            if (res.payload?.status === 201) {
                dispatch(getCompanyEmployeeList(singleCompany?.id));
                dispatch(getUserRoles());
                dispatch(getCompany(singleCompany?.id));
                notifySuccess(t('all.successfully'));
                reset({
                    employee: "",
                    position: '',
                    firstName: '',
                    phone: '',
                    email: '',
                    password: ''
                });
                history.push(mainPath.companiesEmployees.replace(':id', singleCompany?.id));
            } else {
                setButtonLoad(false);
            }
        } catch (err) {
            console.log(err);
            setButtonLoad(false);
        }
    };

    const handleBack = () => {
        if (history.length > 1) {
            history.goBack();
        } else {
            history.push(mainPath.companiesEmployees.replace(':id', singleCompany?.id));
        }
    };
    const resetFieldsAdd = () => {
        clearErrors(['position', 'firstName', 'phone', 'email', 'password']);
    }

    return (
        <div className='companies-customers-wrapper'>
            <div className='companies-customers'>
                <div className='companies-name'>{singleCompany?.name ?? ''}</div>

                <CompaniesHero
                    heading={`${companyEmployeesList.length} ${t('companiesEmployees.headingHero')}`}
                    subHeading={t('companiesEmployees.subHeadingHero')}
                    selectedBack={true}
                    selectedList={false}
                    selectedAdd={false}
                    handleList={handleBack}
                />
                <div className='employees-add'>
                    <div className='employees-add__form'>
                        <div className='employees-add__title'>{t('ProjectsParticipantsAdd.addEmployee')}</div>

                        <div className='employees-add__search'>
                            <div className='employees-add__search-title'>{t('CompaniesEditing.employee_required')}</div>
                            <Controller
                                name='employee'
                                control={control}
                                render={({field}) => (
                                    <AutocompleteMUI
                                        className='no-icons'
                                        text={t('CompaniesPopup.selectFromList')}
                                        array={employeeArr}
                                        value={field.value}
                                        error={errors?.employee}
                                        onChange={(e) => {
                                            field.onChange(e)
                                            resetFieldsAdd()
                                        }}
                                        maxItems={1}
                                        disabled={isAnyFieldFilled} // Disable if any field is filled
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <form className='employees-add__form' onSubmit={handleSubmit(onSubmit)}>
                        <div className='employees-add__info-text'>
                            <div className='text'>{t('all.reg')}</div>
                        </div>

                        <Controller
                            name='position'
                            control={control}
                            render={({field}) => (
                                <SelectComponent
                                    onChange={field.onChange}
                                    onBlur={field.onBlur}
                                    value={position.find((c) => {
                                        return c.id === field.value
                                    })}
                                    error={errors?.position?.message}
                                    options={position}
                                    label={t('ProjectsParticipantsAdd.role')}
                                    placeholder=''
                                    inputProps={field}
                                    disabled={isEmployeeFilled}
                                />
                            )}
                        />

                        <div className='form__input'>
                            <Controller
                                name='firstName'
                                control={control}
                                render={({field}) => (
                                    <InputMUI
                                        type='text'
                                        fullWidth
                                        className='no-icons'
                                        error={errors.firstName?.message}
                                        inputProps={field}
                                        label={t('ProjectsParticipantsAdd.firstName')}
                                        disabled={isEmployeeFilled}
                                    />
                                )}
                            />
                        </div>

                        <div className='form__input'>
                            <Controller
                                name='phone'
                                control={control}
                                render={({field, fieldState: {error}}) => (
                                    <InputMUI
                                        className='no-icons'
                                        type='tel'
                                        fullWidth
                                        error={error?.message}
                                        label={t('ProjectsParticipantsAdd.phone')}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            let cleanValue = value.replace(/[^0-9+]/g, ''); // Remove anything that's not a digit or '+'

                                            if (cleanValue.charAt(0) !== '+') {
                                                cleanValue = cleanValue.replace(/\+/g, ''); // Remove any '+' that is not at the start
                                            } else {
                                                cleanValue = '+' + cleanValue.replace(/\+/g, ''); // Keep only the first '+' and remove others
                                            }

                                            if (/^\+?\d*$/.test(cleanValue)) {
                                                field.onChange(cleanValue);
                                            }
                                        }}
                                        inputProps={field}
                                        disabled={isEmployeeFilled}
                                    />
                                )}
                            />
                        </div>

                        <div className='form__input'>
                            <Controller
                                name='email'
                                control={control}
                                render={({field}) => (
                                    <InputMUI
                                        className='no-icons'
                                        type='email'
                                        fullWidth
                                        error={errors.email?.message}
                                        label={t('ProjectsParticipantsAdd.email')}
                                        inputProps={field}
                                        disabled={isEmployeeFilled}
                                    />
                                )}
                            />
                        </div>

                        <div className='form__input'>
                            <Controller
                                name='password'
                                control={control}
                                render={({field}) => (
                                    <InputMUI
                                        className='no-icons'
                                        type='password'
                                        fullWidth
                                        error={errors.password?.message}
                                        label={t('ProjectsParticipantsAdd.password')}
                                        inputProps={{
                                            ...field,
                                            role: 'presentation',
                                            autoComplete: 'new-password',
                                        }}

                                        disabled={isEmployeeFilled}
                                    />
                                )}
                            />
                        </div>

                        <div className='employees-add__btn'>
                            <ButtonMUI
                                fullWidth
                                type='submit'
                                disabled={!isValid} // Disable button if form is not valid or any field is filled
                                loading={buttonLoad}
                            >
                                {t('ProjectsParticipantsAdd.add')}
                            </ButtonMUI>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EmployeesAdd;
